<template>
<div class="boxShadow">
    <div class="h-crumbOut">
        <div class="h-crumbs">
            <el-breadcrumb separator="|">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/">项目管理</a></el-breadcrumb-item>
                <el-breadcrumb-item><a href="/">盈利测算</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>    
    </div>
    <div class="h-piece">
        <div class="h-pieceTitle2">
            <h1>项目信息</h1>
        </div>
        <div class="h-pieceCon2 xiangmu">
            <el-form :model="formLabelAlign" label-position="right"  :inline="true"  class="demo-ruleForm h-formbLine">
            <el-form-item label="项目名称" class="h-elformWrap-2" >
                <el-input v-model="formLabelAlign.contactInfo" placeholder="自带出"></el-input>
            </el-form-item>
            <el-form-item label="投标方式" class="h-elformWrap-2" >
                <el-input v-model="formLabelAlign.contactInfo" placeholder="请选择"></el-input>
            </el-form-item>
            <el-form-item label="开标日期" class="h-elformWrap-2">
                <el-select v-model="formLabelAlign.type" placeholder="请选择">
                    <el-option label="类型一" value="type1"></el-option>
                    <el-option label="类型二" value="type2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="保修期" class="h-elformWrap-2">
                <el-select v-model="formLabelAlign.type" placeholder="请选择">
                    <el-option label="类型一" value="type1"></el-option>
                    <el-option label="类型二" value="type2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="付款方式" class="h-elformWrap-1" >
                <el-input class="input" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(预付)" style="width:160px;"></el-input>
                <el-input class="input" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(首款)" style="width:160px;margin: 0 28px;"></el-input>
                <el-input class="input3" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(中款)" style="width:160px;margin-right: 27px;"></el-input>
                <el-input class="input4" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(尾款)" style="width:160px;"></el-input>
            </el-form-item>
            <br>
            <el-form-item label="账期" class="h-elformWrap-1" >
                <el-input  placeholder="请输入   天(预付)" style="width:160px;"></el-input>
                <el-input  placeholder="请输入   天(预付)" style="width:160px;margin: 0 28px;"></el-input>
                <el-input  placeholder="请输入   天(预付)" style="width:160px;margin-right: 27px;"></el-input>
                <el-input  placeholder="请输入   %(预付)" style="width:160px;"></el-input>
            </el-form-item>
            <br>
            <el-form-item label="项目背景" class="h-elformWrap-2">
                <el-input v-model="formLabelAlign.contactInfo" placeholder="请输入" style="margin-bottom:15px;"></el-input>
                <el-input v-model="formLabelAlign.contactInfo" placeholder=""></el-input>
            </el-form-item>
            <br>
            <el-form-item label="专营商毛利率" class="h-elformWrap-2" >
                <el-input v-model="formLabelAlign.contactInfo" placeholder="公式计算"></el-input>
            </el-form-item>
            </el-form>
        </div>
    </div>     
    <div style=" margin: 20px 20px 0 20px">
        <el-table
            :data="tables"
            :span-method="objectSpanMethod"
            style="width: 100%"
            :border="true">
            <template v-for='(col) in tableData'>
                <el-table-column
                    :prop="col.dataItem"
                    :label="col.dataName"
                    :key="col.dataItem"
                    width="163px">
                </el-table-column>
            </template>
            
        </el-table>
    </div>
    <div class="enter">
        <el-form :model="formLabelAlign"   :inline="true"  class="demo-ruleForm h-formbLine">
            <el-form-item label="订单总收入(不含税)" class="h-elformWrap-2 footer" style="margin-right:80px">
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" ></el-input>
            </el-form-item>
            <el-form-item label="盈亏平衡(含税价)" class="h-elformWrap-2 footer" style="float:right;">
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" ></el-input>
            </el-form-item>
        </el-form>
    </div>
    <div class="xia">
        <el-row class="xiaC">
            <el-button class="h-btn h-bBtn h-bgwhite">返回</el-button>
            <el-button class=" h-btn h-bBtn h-bggreen" >暂存</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2">确认提交</el-button>
        </el-row>
    </div>
</div>
</template>
<script>
import ss from '../../../api/SystemService'
import yingli from '../../../api/yingli/yingli'
export default {
    data () {
        return {
            formLabelAlign: {
                name: '',
                contact:'',
                contactInfo:'',
                type: '',
                date3: '',
                explain:''
            },
            tables: [{
                xiaoxue: '基本信息',
                chuzhong: '1111',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '西安',
                shangban: '北京'
            },
            {
                chuzhong: '型号',
                gaozhong: '礼泉',
                daxue: '西安',
                yanjiusheng: '西安',
                shangban: '南坊'
            }, 
            {
                chuzhong: '产品大类',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                chuzhong: '产品系列',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {   
                xiaoxue: '收入',
                chuzhong: '终端成交价',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
               
                chuzhong: '单台一级供价',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                
                chuzhong: '折扣率',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                
                chuzhong: '销量',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                
                chuzhong: '申请单价(含税)',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                
                chuzhong: '订单金额',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
             
                chuzhong: '不含税订单收入',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                
                chuzhong: '盈亏平衡含税价',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                xiaoxue: '盈利情况',
                chuzhong: '材料毛利',
                gaozhong: '经营贡献',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                
                chuzhong: '经营贡献',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
               
                chuzhong: '利润',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                xiaoxue: '毛利',
                chuzhong: '单台成本',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
               
                chuzhong: '成本合计',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                chuzhong: '毛利',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
               
                chuzhong: '材料毛利率',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                xiaoxue: '直接费用',
                chuzhong: '附加成本',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            },
            {
                
                chuzhong: '中标服务费',
                gaozhong: '蒲庙',
                daxue: '西安',
                yanjiusheng: '重庆',
                shangban: '北京'
            }],
            tableData: [{
                dataItem: 'xiaoxue',
                dataName: '分类'
            },
            {
                dataItem: 'chuzhong',
                dataName: '科目'
            },
            {
                dataItem: 'gaozhong',
                dataName: '说明'
            }, 
            {
                dataItem: 'daxue',
                dataName: '标准/单台'
            }, 
            {
                dataItem: 'yanjiusheng',
                dataName: '合计-率'
            }, 
            {
                dataItem: 'shangban',
                dataName: '合计-额'
            },
            {
                dataItem: 'xinghao',
                dataName: '型号'
            }
           ]
        }
    },
    created () {
         
    },
    mounted () {
        this.addlie()
    },
    methods: {
        addlie(){
            var that = this;
            ss.yingli.proDetail(this.$route.query.id).then(rd =>{
                console.log(rd.proProductInfoList,"============")
                for(var c =0;c<rd.proProductInfoList.length;c++){
                    var product = rd.proProductInfoList[c].productId;
                    for(var i =0;i<that.tables.length;i++){
                        // that.tables[i].push({
                        //     xinghao: rd.proProductInfoList[c].productId
                        // })
                        that.tables[i].xinghao = product;
                    }
                }
                console.log(that.tables)
            })
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                    rowspan: 4,
                    colspan: 1
                    };
                }else if (rowIndex === 4) {  // 当第7行就为正常的一行；要返回 把1行合并为一列
                    return {
                        rowspan: 8,
                        colspan: 1
                    };
                }else if(rowIndex === 12){
                    return {
                        rowspan: 3,
                        colspan: 1
                    }
                }else if(rowIndex === 15){
                    return {
                        rowspan: 4,
                        colspan: 1
                    }
                }else if(rowIndex === 19){
                    return {
                        rowspan: 2,
                        colspan: 1
                    }
                }else{
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }
            
        },
    }
}
</script>
<style scoped>
   
    .xiaC{
        padding-top: 20px
    }
    .xia{
        margin-left: 400px;
        margin-top: 30px;
        
    }
    .zancun{
        background-color: #24b5b8;
        color: white;
    }
    .h-piece{
        margin: 20px;
    }
    .enter{
        padding:20px 0 0 40px;
        margin: 0 20px 0 20px;
        background-color: #fff;
        height: 1rem;
    }
    .footer{
        width: 41%;
    }
    
</style>
<style >
    .xiangmu .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width:9.7%
    }
    .xiangmu .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width:88.8%
    }
    .xiangmu .h-formbLine  .el-form-item__label{
        width:21%
    }
   .enter .h-formbLine .el-form-item__label{
        width: 37%;
    }
    .enter .h-formbLine .el-form-item__content{
        width: 63%;
    }
</style>

